import { useAuth } from '../../../../context/AuthContext';
import CustomButton from '../../CustomButton';
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../../CustomAlert';

interface PageHeaderProps {
  title: string;
  description: string | React.ReactNode;
  components?: React.ReactNode;
}

const PageHeader = ({ title, description, components }: PageHeaderProps) => {
  const { customerAccountStatus } = useAuth();
  const navigate = useNavigate();

  const navigateToReactivateAccount = () => {
    navigate('/customer/customer-profile');
  };

  return (
    <>
      {customerAccountStatus === 'deactivated' && (
        <div className="flex items-center justify-center w-full mb-4">
          <CustomAlert
            title="Account deactivated"
            description="Your account has been deactivated. You can reactivate it from your account settings."
            color="danger"
            variant="faded"
            endContent={
              <CustomButton
                onPress={() => navigateToReactivateAccount()}
                color="success"
                size="sm"
                variant="flat"
              >
                Reactivate Account
              </CustomButton>
            }
          />
        </div>
      )}

      <div className="flex flex-col laptop:flex-row laptop:justify-between laptop:items-center gap-4 mb-6 mt-4 sm:-mt-2">
        <div className="flex-shrink-0 ">
          <h1 className="font-semibold text-primary text-xl tablet:text-2xl tablet:font-semibold">
            {title}
          </h1>
          <p className="text-sm text-body-mute">{description}</p>
        </div>

        <div className="w-full laptop:w-auto ">{components}</div>
      </div>
    </>
  );
};

export default PageHeader;
